import { useTranslation } from 'react-i18next';
import { CtaLink, GalleryPage } from '../shared/GalleryPage';

export function EmptyCart() {
  const { t } = useTranslation();

  return (
    <GalleryPage
      title={t('Your cart is empty')}
      subtitle={t(
        'Get your products now and start creating something awesome.',
      )}
    >
      {window.PRICING_PAGE && (
        <CtaLink href={window.PRICING_PAGE}>
          {t('Explore our products')}
        </CtaLink>
      )}
    </GalleryPage>
  );
}
